import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { AppShell } from "@/components/layout/app-shell";
import { hasAnyKnownRole } from "@/auth/role-guard";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated")({
  validateSearch: searchSchema,
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }
    // Usuario autenticado pero sin ningún grupo reconocido (p. ej. cuenta recién
    // creada sin rol asignado): no tiene acceso a nada → mándalo a access-denied
    // en vez de dejarlo en un panel que responde 403 en cada llamada. Se exceptúa
    // la propia ruta access-denied para no crear un bucle de redirección.
    if (
      location.pathname !== "/access-denied" &&
      !hasAnyKnownRole(context.auth.user?.groups)
    ) {
      throw redirect({ to: "/access-denied" });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
